export const MESSAGE_STREAMING_PUT_DELAY_MS = 8;
export const MESSAGE_LOADING_PLACEHOLDER = 'Thinking...';

export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const ChatSystemRoleNameForAgent = 'agent';
export const ChatSystemRoleNameForUser = 'user';

const SenderRoles = [
  ChatSystemRoleNameForAgent,
  ChatSystemRoleNameForUser,
] as const;

export type SenderRole = (typeof SenderRoles)[number];
